import __request__ from "routing/request";
export function get(requestOptions) {
  return __request__("GET", "/telemetry", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function saveTelemetryUserSettings(JSONbody, requestOptions) {
  return __request__("PUT", "/telemetry/user/settings", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getTelemetryUserSettings(requestOptions) {
  return __request__("GET", "/telemetry/user/settings", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
